import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import AppContext from '../../AppContext';

import './ErrorLayout.scss';

const ErrorLayout = () => {
  const context = useContext(AppContext);
  const {
    actions,
    state: {
      theme,
      footer,
      contentFooter,
      step,
      hasError,
      shouldReset,
      errorHeader,
      errorDetail,
      backToComponent,
      backToPage
    }
  } = context;

  const closeError = () => {
    if (shouldReset) {
      // RESET ALL STATE except theme, footer
      const exceptionData = {
        theme,
        footer,
        contentFooter
      };

      actions.resetState(exceptionData);
      return false;
    }

    let opt = {
      hasError: false,
      errorHeader: '',
      errorDetail: ''
    };

    if (backToComponent) {
      opt = {
        ...opt,
        step: {
          ...step,
          component: backToComponent
        }
      };
    }

    actions.setData({
      ...opt
    });
  };

  const errorMessages = errorDetail.trim().split('\n');

  return (
    <div className="errorModal">
      <div className={cx(hasError && 'errorModal__block')}>
        <div className="errorModal-message-area">
          <h3 className="errorModal-header">{errorHeader || '안내'}</h3>
          <div className="errorModal-message">
            {errorMessages.map((msg, idx) => (
              <p key={idx}>{msg}</p>
            ))}
          </div>
          {/* <button onClick={() => removeError()}>Remove error dev</button> */}
          <button className="errorModal-button" onClick={() => closeError()}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorLayout;
